import topic from '../topic'
export const factAPI = {
    get_facts: topic.factTopic + '/get_facts',
    addFacts: topic.factTopic + '/add_fact',
    editFacts: topic.factTopic + '/edit_fact',
    deleteFacts: topic.factTopic + '/delete_fact_by_ids',
    get_fact_by_id: topic.factTopic + '/get_fact_by_id',
    createQrcode: topic.factTopic + '/create_qrcode',//生成二维码
}